<template>
<div class='bodyer login'>
    <div class='container'>
        <div class='box-form'>
            <div class='row'>
                <div class='col-md-offset-7 col-md-5'>
                    <div class='box-tab'>
                        <div class='top-tip'>专属通行证，玩转应答旗下游戏</div>
                        <ul class='nav nav-tabs'>
                            <li class='active'>
                                <a data-toggle='tab' data-target='#by-username'>
                                    <span><i class='icon iconfont icon-mima'></i>邮箱登录</span>
                                </a>
                            </li>
                            <li>
                                <a data-toggle='tab' data-target='#by-mobile'>
                                    <span><i class='icon iconfont icon-youxiang'></i>短信登录</span>
                                </a>
                            </li>
                        </ul>
                        <div class='tab-content'>
                            <div class='tab-pane fade in active tab-form' id='by-username'>
                                <div class='form form-username'>
                                    <div class='form-group'>
                                        <input type='text' class='form-control' 
                                            v-model='by_username.username'
                                            placeholder='邮箱/手机号/原网站账号' pattern='^\d{11}$|^[_A-z0-9]{3,12}@.{3,8}|^[_A-z0-9]{5,16}$' required
                                            data-error='请输入邮箱或手机号或原网站账号'>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='form-group'>
                                        <input type='password' class='form-control' 
                                            v-model='by_username.password'
                                            placeholder='密码:' pattern='^[_A-z0-9]{6,20}' required
                                            data-error='6-20位数字、字母或下划线'>
                                            <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='form-group row'>
                                        <div class='col-md-7'>
                                            <input type='text' class='form-control'
                                                v-model='by_username.image_code' 
                                                placeholder='验证码' required
                                                pattern='[A-z0-9]{5}' data-error='验证码格式错误'>
                                        </div>
                                        <div class='col-md-5'>
                                            <img :src='image_code_url+by_username.image_code_key'
                                                class='verify-code-img' 
                                                @click='changeImageCode(by_username)' 
                                                data-toggle='tooltip' title='点击更换'>
                                        </div>
                                    </div>
                                    <div class='tip'>
                                        <a href='/#/service/faq?type=repass'>忘记密码？</a>
                                    </div>
                                    <div class='form-group'>
                                        <button class='btn btn-warning btn-block' @click='loginByUsername()'>登录</button>
                                    </div>
                                    <br>
                                    <!-- <div class='tip'>
                                        <a href='/#/service/faq?type=repass'>无法登录？</a>
                                    </div> -->
                                    <div class='tip-2'>
                                        还没有应答通行证?<a href='/#/register'>立即注册</a>
                                    </div>
                                </div>
                            </div>
                            <div class='tab-pane fade tab-form' id='by-mobile'>
                                <div class='form form-mobile'>
                                    <div class='form-group'>
                                        <input type='text' class='form-control' 
                                            v-model='by_mobile.mobile' pattern='^[0-9]{11}$'
                                            placeholder='手机号码' required 
                                            data-error='请输入手机号'>
                                        <div class='help-block with-errors'></div>
                                    </div>
                                    <div class='form-group'>
                                        <div class='input-group'>
                                            <input type='text' class='form-control'
                                                v-model='by_mobile.sms_code' pattern='^[0-9]{6}$'
                                                data-error='请输入6位数字验证码' 
                                                placeholder='验证码' required>
                                            <span class='input-group-btn'>
                                                <button class='btn btn-default' type='button'
                                                    @click='sendSms()' v-if='!this.forbid_sms'>
                                                    免费获取
                                                </button>
                                                <button class='btn btn-default' type='button'
                                                    disabled v-if='this.forbid_sms'>
                                                    {{forbid_sms}}s后重新发送
                                                </button>
                                            </span>
                                        </div>
                                        <div class='help-block with-errors'></div>
                                    </div>
                                    <!-- <div class='tip'><a href=''>忘记密码？</a></div> -->
                                    <div class='form-group'>
                                        <button class='btn btn-warning btn-block' 
                                            @click='loginByMobile()'>登录</button>
                                    </div>
                                    <!-- <div class='tip'><a href=''>无法登录？</a></div> -->
                                    <div class='tip-2'>
                                        还没有应答通行证?<a href='/#/register'>立即注册</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class='box-link'>
        <div class='container'>
            <me-link></me-link>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Storage from '@/common/Storage'
import Request from '@/common/Request'
import Notify from '@/common/Notify'
import Common from '@/common/Common'
import Config from '@/common/Config'
import ScrollReveal from 'scrollreveal'
import Link from '@/components/util/Link'
export default {
    data : function(){
        return {
            'forbid_sms' : false,
            'image_code_url' : Config.api_url+'/public/image-code?key=',
            'by_username' : {
                'username' : '',
                'password' : '',
                'image_code' : '',
                'image_code_key' : Math.random().toString()
            },
            'by_mobile' : {
                'mobile' : '',
                'sms_code' : ''
            }
        }
    },
    components: {
        'me-link': Link
    },
    props : ['setUser'],
    methods : {
        //用户名登录
        loginByUsername : function(){
            if($('.form-username').data('bs.validator').validate().hasErrors()){
                return true
            }

            var url = Request.createApi('/app/login')

            Request.post(url, this.by_username, res => {
                window._hmt.push(['_trackEvent', 'user', 'user_login', this.by_username.username]);
                this.setUser(res.info)
                Notify.notice('恭喜您，登录成功！')
                Common.toUrl('/user')
            })
        },

        //验证码发送
        sendSms : function(){
            if(!/[0-9]{11}/.test(this.by_mobile.mobile)){
                Notify.error('手机号输入错误!')
                return false
            }
            
            var url = Request.createApi('/public/send-sms-code')
            var param = {
                'mobile' : this.by_mobile.mobile
            }
            Request.post(url, param, res => {
                Notify.success('验证码已发送!')
                this.forbid_sms = 60
                var loop = setInterval(() => {
                    this.forbid_sms--
                    if(this.forbid_sms < 1){
                        this.forbid_sms = false
                        clearInterval(loop)
                    }
                }, 1000)
            })
        },

        //手机号登录
        loginByMobile : function(){
            if($('.form-mobile').data('bs.validator').validate().hasErrors()){
                return false
            }

            var url = Request.createApi('/app/login-by-mobile')
            Request.post(url, this.by_mobile , res => {
                this.setUser(res.info)
                Notify.notice('恭喜您，登录成功！')
                Common.toUrl('/user')
            })
        },

        //刷新验证码
        changeImageCode : function(form){
            form.image_code_key = Math.random().toString()
        }
    },
    mounted : function(){
        $(function () { 
            $("[data-toggle='tooltip']").tooltip(); 
            $('.form-username').validator()
            $('.form-mobile').validator()
        });    
        var show = ScrollReveal({
            'origin' : 'bottom',
            'distance' : '200px',
            'duration' : 500,
        });

        show.reveal('.box-form', {'origin' : 'right'})

        show.reveal('.box-tab', {'origin' : 'right'})

        $('.c-link-class').each(function(k){
            show.reveal($(this), {
                delay: k*200 + 200
            })
        })
    },
    created : function(){
        window.scrollTo(0, 0)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/user/Login.vue